import React, { createContext, useEffect, useState } from "react";

export const PageContext = createContext();

/**
 * tabs 안에 띄어지는 모든 page에서 공유하는 상태 값
 * 외부에서 <PageProvider>로 감싸야 children으로 인정 됨
 */
export function PageProvider({ children }) {
	const [gnbId, setGnbId] = useState("");
	const [lnbId, setLnbId] = useState("");
	const [snbId, setSnbId] = useState("");
    const contextValue = {
		gnbId, setGnbId,
		lnbId, setLnbId,
		snbId, setSnbId,
    };

    return <PageContext.Provider value={contextValue}>{children}</PageContext.Provider>;
}
